import { atom, AtomEffect } from "recoil";

type MeasureRangeValues = {
  startPixel: number;
  endPixel: number;
  fixPixel: number;
  cmLabel: string;
  inLabel: string;
  minValue: number;
  maxValue: number;
  average: number;
};

export const MEASURE_RANGE_VALUES: MeasureRangeValues[] = [
  {
    startPixel: 0,
    endPixel: 44,
    fixPixel: 4,
    cmLabel: "Over 183cm+",
    inLabel: `6' & over`,
    minValue: 183,
    maxValue: Infinity,
    average: 183,
  },
  {
    startPixel: 45,
    endPixel: 124,
    fixPixel: 85,
    cmLabel: "170cm - 183cm",
    inLabel: `5' 7" - 6'`,
    minValue: 170,
    maxValue: 183,
    average: 176,
  },
  {
    startPixel: 126,
    endPixel: 204,
    fixPixel: 164,
    cmLabel: "154cm - 169cm",
    inLabel: `5' 1" - 5' 6"`,
    minValue: 154,
    maxValue: 169,
    average: 161,
  },
  {
    startPixel: 205,
    endPixel: 284,
    fixPixel: 244,
    cmLabel: "140cm - 153cm",
    inLabel: `4' 7" - 5'`,
    minValue: 140,
    maxValue: 153,
    average: 146,
  },
  {
    startPixel: 285,
    endPixel: 364,
    fixPixel: 324,
    cmLabel: "124cm - 139cm",
    inLabel: `4' 1" - 4' 6"`,
    minValue: 124,
    maxValue: 139,
    average: 131,
  },
  {
    startPixel: 365,
    endPixel: 444,
    fixPixel: 404,
    cmLabel: "123cm & Under",
    inLabel: `4' & under`,
    minValue: 0,
    maxValue: 123,
    average: 123,
  },
];

const sessionStorageEffect =
  <T>(key: string): AtomEffect<T> =>
  ({ setSelf, onSet }) => {
    const savedValue = sessionStorage.getItem(key);
    if (savedValue != null) {
      setSelf(JSON.parse(savedValue));
    }

    onSet((newValue, _, isReset) => {
      isReset
        ? sessionStorage.removeItem(key)
        : sessionStorage.setItem(key, JSON.stringify(newValue));
    });
  };

export const childFirstNameState = atom({
  key: "childFirstName",
  default: "",
  effects: [sessionStorageEffect("childFirstName")],
});

export const childLastNameState = atom({
  key: "childLastName",
  default: "",
  effects: [sessionStorageEffect("childLastName")],
});

export const displayNameState = atom({
  key: "displayName",
  default: "",
  effects: [sessionStorageEffect("displayName")],
});

export const childDobState = atom({
  key: "childDob",
  default: "",
  effects: [sessionStorageEffect("childDob")],
});

export const childHeightOptionState = atom({
  key: "childHeight",
  default: MEASURE_RANGE_VALUES[4].average,
  effects: [sessionStorageEffect("childHeight")],
});
